import PropTypes from 'prop-types';
import { getMMValueWithInverted } from '../utils';

export const MarkingArrows = ({
  markingImg,
  markingPosition,
  markingWidth,
  markingHeight,
  markingRotate,
  markingZoneWidth,
  markingZoneHeight,
}) => {
  const isInverted = [90, 270].includes(markingRotate);

  const positionLeft = isInverted ? markingPosition.x + markingWidth / 2 - markingHeight / 2 : markingPosition.x;
  const positionTop = isInverted ? markingPosition.y + markingHeight / 2 - markingWidth / 2 : markingPosition.y;

  const positionRight = markingZoneWidth - positionLeft - (isInverted ? markingHeight : markingWidth);
  const positionBottom = markingZoneHeight - positionTop - (isInverted ? markingWidth : markingHeight);

  const arrowRightStyles = { top: `${markingPosition.y + markingHeight / 2}px`, width: `${positionLeft}px` };
  const arrowDownStyles = { left: `${markingPosition.x + markingWidth / 2}px`, height: `${positionTop}px` };
  const arrowLeftStyles = { top: `${markingPosition.y + markingHeight / 2}px`, width: `${positionRight}px` };
  const arrowUpStyles = { left: `${markingPosition.x + markingWidth / 2}px`, height: `${positionBottom}px` };

  if (!markingImg?.src || !markingPosition) {
    return;
  }

  return (
    <>
      <i
        className="arrow arrow-right"
        style={arrowRightStyles}
        data-value={`${getMMValueWithInverted(markingImg, isInverted, 'x')}`}
      ></i>
      <i
        className="arrow arrow-down"
        style={arrowDownStyles}
        data-value={`${getMMValueWithInverted(markingImg, isInverted, 'y')}`}
      ></i>
      <i
        className="arrow arrow-left"
        style={arrowLeftStyles}
        data-value={`${getMMValueWithInverted(markingImg, isInverted, '-x')}`}
      ></i>
      <i
        className="arrow arrow-up"
        style={arrowUpStyles}
        data-value={`${getMMValueWithInverted(markingImg, isInverted, '-y')}`}
      ></i>
    </>
  );
};

MarkingArrows.propTypes = {
  markingImg: PropTypes.object,
  markingPosition: PropTypes.object.isRequired,
  markingWidth: PropTypes.number.isRequired,
  markingHeight: PropTypes.number.isRequired,
  markingRotate: PropTypes.number.isRequired,
  markingZoneWidth: PropTypes.number.isRequired,
  markingZoneHeight: PropTypes.number.isRequired,
};
